import React, { Fragment, useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../../common/RequiredInputs'
import _ from 'lodash'
import { hospitalsApi } from '../../../../api/hospitalsApi'

const AddHospitalToContactForm = ({
  inputs,
  departaments,
  positions,
  specialties,
  timeSlots,
  handleChange,
  handleChangeSelect,
}) => {
  const id_Hospital = inputs.id_Hospital.toString()

  const [hospitalOptions, setHospitalOptions] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [showDropdown, setShowDropdown] = useState(false)
  const [selectedHospitalName, setSelectedHospitalName] = useState('')

  useEffect(() => {
    const onMount = async () => {
      const response = await hospitalsApi.getAllHospitalsAndZones(0)
      const options = response.data.map((x) => ({
        label: x.nombre,
        value: x.id_Hospital.toString(),
      }))
      setHospitalOptions(options)
      
      // Si ya hay un hospital seleccionado, establecer su nombre
      if (inputs.id_Hospital) {
        const selectedHospital = options.find(opt => opt.value === inputs.id_Hospital.toString())
        if (selectedHospital) {
          setSelectedHospitalName(selectedHospital.label)
        }
      }
    }
    onMount()
  }, [inputs.id_Hospital])

  const onChangeHospitalSelect = (e) => {
    const selectedOption = hospitalOptions.find(
      (option) => option.value === e.target.value,
    )
    handleChangeSelect(selectedOption, 'id_Hospital')
  }

  const handleSearchChange = async (e) => {
    const value = e.target.value
    setSearchTerm(value)
    setSelectedHospitalName(value)
    setShowDropdown(true)

    // Buscar hospitales
    const response =
      value != null && value != ""
        ? await hospitalsApi.getAllHospitalsBySearch(value)
        : await hospitalsApi.getAllHospitalsAndZones(0)
    
    const options = response.data.map((x) => ({
      label: x.nombre,
      value: x.id_Hospital.toString(),
    }))
    setHospitalOptions(options)
  }

  const handleHospitalSelection = (hospital) => {
    setSelectedHospitalName(hospital.label)
    setSearchTerm('')
    setShowDropdown(false)
    handleChangeSelect(hospital, 'id_Hospital')
  }

  const handleInputFocus = () => {
    setShowDropdown(true)
  }

  const handleInputBlur = () => {
    // Delay to allow click on dropdown
    setTimeout(() => setShowDropdown(false), 200)
  }

  const hospitales = _.orderBy(hospitalOptions, ['label'], ['asc'])
  const especialidades = _.orderBy(specialties, ['nombre'], ['asc'])
  const departamentos = _.orderBy(departaments, ['nombre'], ['asc'])
  const cargos = _.orderBy(positions, ['nombre'], ['asc'])

  return (
    <Fragment>
      <div className='col-12 col-md-6'>
        <Form.Group size='lg'>
          <Form.Label className='form__labels'>
            Hospital / Centro <RequieredInputs />{' '}
          </Form.Label>
          <div style={{ position: 'relative' }}>
            <Form.Control
              placeholder='Buscar hospital...' 
              value={selectedHospitalName}
              onChange={handleSearchChange}
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
              className='user-input form__input'
              required
            />
            {showDropdown && hospitalOptions.length > 0 && (
              <div
                class="app-hospital-combo"
                style={{
                
              }}>
                {hospitales.map((hospital) => (
                  <div
                    key={hospital.value}
                    onClick={() => handleHospitalSelection(hospital)}
                    style={{
                      padding: '8px 12px',
                      cursor: 'pointer',
                    }}
                  >
                    {hospital.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </Form.Group>
      </div>
      <div className='col-12 col-md-4 col-lg-6'>
        <Form.Group size='lg'>
          <Form.Label className='form__labels'>
            Departamento <RequieredInputs />
          </Form.Label>
          <Form.Control
            className='user-input form__input'
            as='select'
            name='id_TipoDepartamento'
            value={inputs.id_TipoDepartamento}
            onChange={handleChange}
            required
          >
            <option className='products__text-readOnly' hidden>
              Elegir Departamento
            </option>
            {departamentos
              ? departamentos.map((department) => (
                  <option
                    key={department.id_TipoDepartamento}
                    value={department.id_TipoDepartamento}
                  >
                    {department.nombre}
                  </option>
                ))
              : null}
          </Form.Control>
        </Form.Group>
      </div>
      <div className='col-12 col-md-4 col-lg-6'>
        <Form.Group size='lg'>
          <Form.Label className='form__labels'>
            Especialidad <RequieredInputs />
          </Form.Label>
          <Form.Control
            className='user-input form__input'
            as='select'
            type='text'
            name='id_TipoEspecialidad'
            value={inputs.id_TipoEspecialidad}
            onChange={handleChange}
            placeholder='Especialidad'
            required
          >
            <option className='products__text-readOnly' hidden>
              Elegir Especialidad
            </option>
            {especialidades
              ? especialidades.map((specialty) => (
                  <option
                    key={specialty.id_TipoEspecialidad}
                    value={specialty.id_TipoEspecialidad}
                  >
                    {specialty.nombre}
                  </option>
                ))
              : null}
          </Form.Control>
        </Form.Group>
      </div>
      <div className='col-12 col-md-6 col-lg-3'>
        <Form.Group size='lg'>
          <Form.Label className='form__labels'>
            Cargo <RequieredInputs />
          </Form.Label>
          <Form.Control
            className='user-input form__input'
            as='select'
            type='text'
            name='id_TipoCargo'
            value={inputs.id_TipoCargo}
            onChange={handleChange}
            placeholder='Cargo'
            required
          >
            <option className='products__text-readOnly' hidden>
              Elegir Cargo
            </option>
            {cargos
              ? cargos.map((position) => (
                  <option
                    key={position.id_TipoCargo}
                    value={position.id_TipoCargo}
                  >
                    {position.nombre}
                  </option>
                ))
              : null}
          </Form.Control>
        </Form.Group>
      </div>
      <div className='col-12 col-md-6 col-lg-3'>
        <Form.Group size='lg'>
          <Form.Label className='form__labels'>Horario</Form.Label>
          <Form.Control
            className='user-input form__input'
            as='select'
            type='text'
            name='id_TipoFranjaHoraria'
            value={inputs.id_TipoFranjaHoraria}
            onChange={handleChange}
          >
            <option value={''}>Franja horaria</option>
            {timeSlots.length > 0
              ? timeSlots.map((time) => (
                  <option
                    key={time.id_TipoFranjaHoraria}
                    value={time.id_TipoFranjaHoraria}
                  >
                    {time.nombre}
                  </option>
                ))
              : null}
          </Form.Control>
        </Form.Group>
      </div>
    </Fragment>
  )
}
export default AddHospitalToContactForm
